// format meters to km, eg. 1900 -> 1,9
export default function formatDistance(meters) {
  return (meters / 1000).toFixed(1);
}

